import { render, staticRenderFns } from "./hrd-accreditors.vue?vue&type=template&id=225ff6c6&scoped=true"
import script from "./hrd-accreditors.vue?vue&type=script&lang=js"
export * from "./hrd-accreditors.vue?vue&type=script&lang=js"
import style0 from "./hrd-accreditors.vue?vue&type=style&index=0&id=225ff6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ff6c6",
  null
  
)

export default component.exports